import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';
import {
  ColumnProperties,
  EditColumnsDropdown as EditColumnsDropdownButton,
} from 'pages/Shipments/components/ContainerActions/EditColumnsDropdown';
import _ from 'lodash';
import * as React from 'react';
import { getActiveColumns } from '../../../Table/columns';
import { PresetView } from '../../../types';

interface Props {
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityChange: (model: GridColumnVisibilityModel) => void;
  presetView: PresetView;
}

const generateColumnStates = (columnVisibilityModel: GridColumnVisibilityModel) => {
  const columns = getActiveColumns();
  return Object.keys(columnVisibilityModel)
    .filter((key) => !!columns.find((c) => c.field === key))
    .map((key) => {
      return {
        label: columns.find((c) => c.field === key)?.headerName || key,
        visible: columnVisibilityModel[key],
        key,
      };
    });
};

export const EditColumns: React.FC<Props> = (props) => {
  const { columnVisibilityModel, onColumnVisibilityChange, presetView } = props;

  const columnStates = React.useMemo(
    () => generateColumnStates(columnVisibilityModel),
    [columnVisibilityModel]
  );

  const handleSetColumnsStates = (newColumnStates: ColumnProperties[]) => {
    onColumnVisibilityChange(_.mapValues(_.keyBy(newColumnStates, 'key'), 'visible'));
  };

  return (
    <EditColumnsDropdownButton
      columnStates={columnStates}
      setColumnStates={handleSetColumnsStates}
      presetView={presetView}
      usage="shipments"
    />
  );
};
EditColumns.displayName = 'Shipments.Containers.ActionBar.EditColumns';
